// inactivity.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { PathEnum } from '../enums/pathEnum';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { UserUtil } from '../utils/user.util';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class InactivityService {
    timeoutId: any;
    userInactive: Subject<any> = new Subject();
    isMonitoring: boolean = false;
  
    constructor(
        private router: Router,
        private dialog: MatDialog
    ) {
        this.userInactive.subscribe(
            () => {
                if(this.isMonitoring){
                    this.sessionLock()
                }
            }
        );
    }
  
    startMonitoring() {
      if (!this.isMonitoring) {
        this.setupActivityMonitoring();
        this.isMonitoring = true;
      }
    }
  
    stopMonitoring() {
      if (this.isMonitoring) {
        clearTimeout(this.timeoutId);
        this.isMonitoring = false;
      }
    }
  
    setTimeout() {
      this.timeoutId = setTimeout(() => this.userInactive.next(undefined), 1000 * 60 * 1440); // 1440 minutes => 1 day // TODO : To change for the same than the backend token
    }
  
    resetTimeout() {
      clearTimeout(this.timeoutId);
      this.setTimeout();
    }
  
    setupActivityMonitoring() {
      window.onload = () => this.resetTimeout();
      document.onmousemove = () => this.resetTimeout();
      document.onkeydown = () => this.resetTimeout();
    }

    private closeAllModals(): void {
        this.dialog.closeAll();
    }

    sessionLock() {
        const currentPath = this.router.url;
        const partnerUnlockPath = `${PathEnum.BASE_URL}${PathEnum.SESSION}/${PathEnum.SESSION_UNLOCK_SESSION}`;
        const teamUnlockPath = `${PathEnum.BASE_URL}${PathEnum.APP_TEAM}/${PathEnum.SESSION}/${PathEnum.SESSION_UNLOCK_SESSION}`;
    
        if (!currentPath.startsWith(partnerUnlockPath) && !currentPath.startsWith(teamUnlockPath)) {
            this.closeAllModals();

            const user = AuthUtils.getUserToken();
            const redirectURL = currentPath;
    
            if(UserUtil.isPartnerUser(user)){
                this.router.navigate([PathEnum.BASE_URL, PathEnum.SESSION, PathEnum.SESSION_UNLOCK_SESSION], { queryParams: { redirectURL } });
            } else if(UserUtil.isTeamUser(user)) {
                this.router.navigate([PathEnum.BASE_URL, PathEnum.APP_TEAM, PathEnum.SESSION, PathEnum.SESSION_UNLOCK_SESSION], { queryParams: { redirectURL } });
            } else {
                console.error("Unknown user type");
                this.router.navigate([PathEnum.BASE_URL, PathEnum.SESSION, PathEnum.SESSION_UNLOCK_SESSION], { queryParams: { redirectURL } });
            }    
        }
    }
}
